<template>
  <div class="customize-form-thumbnail">
    <template v-for="item of urls">
      <img
        :key="item.url + 'img'"
        class="customize-form-thumbnail-img"
        :src="item.url"
        :alt="item.filename"
        :style="{ background: '#' + item.color.toString(16) }"
      />
      <div :key="item.url + 'mask'" class="customize-form-thumbnail-mask" @click="onDetail(item.url, item.filename)">
        <zoom-in-icon class="customize-form-thumbnail-zoomin" />
      </div>
    </template>
  </div>
</template>

<script>
import FileDetailModal from './fileDetail';
import ZoomInIcon from './icon/zoomIn';

export default {
  name: 'Thumbnail',
  components: {
    ZoomInIcon,
  },
  props: {
    urls: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    onDetail(url, filename) {
      FileDetailModal.show({
        url,
        filename,
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.customize-form-thumbnail {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: var(--customize-form-border-radius);
  overflow: hidden;

  &-img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &-mask {
    position: absolute;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: rgba(0,0,0,0.3);
    cursor: pointer;
    border-radius: var(--customize-form-border-radius);
    border-bottom-right-radius: 0;
  }

  &-zoomin {
    width: 20px;
    height: 20px;

    ::v-deep {
      path {
        fill: #ffffff !important;
      }
    }
  }
}
</style>